import { Component, AfterViewInit, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';

import * as Services from '@shared/core/services';

import * as Decorators from '@shared/core/decorators';
@Decorators.Meta({
    title: '404 Error - Page not found',
    keywords: ' ',
    description: ' ',
})
@Component({
    template: '<div>This component requires extending</div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error404Component implements AfterViewInit, OnInit, OnDestroy {
    public title: string = 'The link you followed may be broken, or the page may have been removed.';
    public description: string = null;
    public homeLink: boolean = true;
    public imgSrc: string = '';

    constructor(
        public initService: Services.InitService,
    ) { }

    ngAfterViewInit(): void {
        this.initService.unsetSplashLoader();
    }

    ngOnInit(): void { }

    ngOnDestroy(): void { }
}
